import { ComponentPropsWithoutRef, ReactNode, forwardRef } from 'react';

import classNames from 'classnames';

import { DialogBody } from '@backstage/ui';

import styles from './BodyBui.module.css';

export type BodyBuiProps = Omit<ComponentPropsWithoutRef<'div'>, 'children'> & {
  children: ReactNode;
  variant?: 'dense';
  autoHeight?: boolean;
};

export const BodyBui = forwardRef<HTMLDivElement, BodyBuiProps>(
  (props, ref) => {
    const { className, variant, autoHeight, ...rest } = props;

    return (
      <DialogBody
        {...rest}
        ref={ref}
        className={classNames(styles.root, className, {
          [styles.dense]: variant === 'dense',
          [styles.autoHeight]: autoHeight,
        })}
      />
    );
  },
);

BodyBui.displayName = 'DialogCompositeBui.Body';

export default BodyBui;
